import { get_axios_instance, api_variables, errorHandler, errorLogSheet } from '@/apis/variables.js';
import Vue from 'vue';

var axios_intsace_getcomponent=get_axios_instance(api_variables.SERVICE_FBP_COMPONENT_LIST)
var axios_instance_get = get_axios_instance(api_variables.SERVICE_FBP_DECLARE_GET);
var axios_instance_update = get_axios_instance(api_variables.SERVICE_FBPUPDATE);
var axios_instance_getslabid=get_axios_instance(api_variables.SERVICE_FBP_SLAB_ID)
var axios_instance_post=get_axios_instance(api_variables.SERVICE_FBP_DECLARE_POST)
var axios_instance_download_bulk_declaration= get_axios_instance(api_variables.SERVICE_FBP_DOWNLOAD_BULK_DECLARATION);
var axios_instance_upload_bulk_declaration = get_axios_instance(api_variables.SERVICE_FBP_UPLOAD_BULK_DECLARATION)

const _pk_name = "id";

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, [payload, id]) => {
        Vue.set(state.entityWiseData, id, payload);
    },

    addEntity: (state, [payload, id]) => {
        state.entityWiseData[id].push(payload);
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] === payload.id) {
                state.entityWiseData[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] == payload) {
                state.entityWiseData[id].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        //console.log(state.record)
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
           //console.log("i am action new one",payload)
           
        try {
            commit("setFetching", true);
            let res = await axios_instance_get.get(`/${payload.emp_id}`, {
                 
                params:
                {
                  le_id :payload.le_id,
                  emp_id :payload.emp_id,
                }
                    
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", [res.data.payload, payload]);
                //console.log("i am action new one",res)
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async fetchFBP_component({ commit }, payload) {
        //console.log("i am action new one",payload)
        
     try {
         commit("setFetching", true);
         let res = await axios_intsace_getcomponent.get(`/`, {
              
                 params:
                {
                  le_id :payload.le_id,
                  emp_id :payload.emp_id,
                }
                 
                 
         });
         commit("setFetching", false);
         if (res.status == 200) {
             commit("set", [res.data.payload, payload]);
             //console.log("i am action new one",res)
         }
         return res;
     } catch (err) {
         throw errorHandler(err.response);
     }
 },

   

    async create({ commit }, payload) {
        //console.log("i am eneterd",payload )
        try {
            commit("setSaving", true);
            let res = await axios_instance_post.put("/", payload);
            //console.log("i am eneterd",payload )
            //console.log("i am eneterd",res)
            commit("setSaving", false);
            if (res.status == 201) {
                commit("addEntity", [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },


    async fetchingfbpslabcomponent({ commit }, payload) {
        //console.log("i am eneterd to fetchingfbpslabcomponent",payload )
        try {
            commit("setFetching", true);
            let res = await  axios_instance_getslabid.get("/",
            {
             params: 
              payload
            });
            //console.log("i am eneterd to action of fbp component",res.data.payload)
            commit("setFetching", false);
            if (res.status == 201) {
                commit("addEntity", [res.data.payload, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, id]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance_update.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data.payload, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    

    async delete({ commit }, [payload, id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getDeclarationTemplate({commit},payload) {
        try {
          let res = await axios_instance_download_bulk_declaration.get(`/`, {
            params: payload
          });
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "FBP Declaration"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(err);
        }
    },

    async fbpDeclarationUploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_bulk_declaration.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorLogSheet(err.response);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};